export default "__VITE_ASSET__BTXeWeK5__"